import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/car-loan-comparison',
  component: () => import('../../routes/CarLoanComparison.svelte'),
  card: {
    id: 'car-loan-comparison',
    title: 'Car Loan Comparison',
    description:
      'Compare dealership vs. bank financing to find the best deal on your next car loan.',
    icon: 'directions_car',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/car-loan-comparison',
    category: 'Loans & Debt',
  },
  seo: {
    title: 'Car Loan Comparison Calculator — Dealership vs. Bank Financing',
    description:
      'Compare car loan offers from dealerships and banks/credit unions. Calculate effective APR, monthly payments, and total cost to find the best financing deal.',
  },
};

export default meta;